const CALCULATE_BASKET_PRICE_REQUEST = 'CALCULATE_BASKET_PRICE_REQUEST'
const CALCULATE_BASKET_PRICE_SUCCESS = 'CALCULATE_BASKET_PRICE_SUCCESS'
const CALCULATE_BASKET_PRICE_FAILURE = 'CALCULATE_BASKET_PRICE_FAILURE'

export { CALCULATE_BASKET_PRICE_REQUEST, CALCULATE_BASKET_PRICE_SUCCESS, CALCULATE_BASKET_PRICE_FAILURE }
